import { render, staticRenderFns } from "./expenditure.vue?vue&type=template&id=b3cd0250&scoped=true"
import script from "./expenditure.vue?vue&type=script&lang=js"
export * from "./expenditure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3cd0250",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3cd0250')) {
      api.createRecord('b3cd0250', component.options)
    } else {
      api.reload('b3cd0250', component.options)
    }
    module.hot.accept("./expenditure.vue?vue&type=template&id=b3cd0250&scoped=true", function () {
      api.rerender('b3cd0250', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fd/setup/cate/expenditure.vue"
export default component.exports